import React from 'react'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import CreateForm from './partials/CreateForm'

import access from '../../utils/access'
import user from '../../utils/user'

@inject('Auth', 'User', 'Ticket', 'Community')
@observer
export class SupportCreate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        subject: '',
        content: '',
        comId: -1,
        category: 0,
        priority: 0
      }
    }
  }

  componentWillMount () {
    const _findTickets = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findTickets()
        }

        this.props.Community.getMyCommunities()
      }, 500)
    }

    _findTickets()
  }

  onFormSubmit (e) {
    e.preventDefault()

    const data = {
      title: this.state.editor.subject,
      content: this.state.editor.content,
      comId: this.state.editor.comId,
      priority: this.state.editor.priority,
      category: this.state.editor.category
    }

    if (data.title.length < 1 && data.content.length < 1) {
      return
    }

    if (data.comId === -1) {
      delete data.comId
    }

    this.props.Ticket.postTicket(data).then(ticket => {
      this.props.history.push(`/dashboard/support/${ticket.id}`)
    })
  }

  onInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        [e.target.name]: e.target.value
      }
    })
  }

  onCategoryChange (e) {
    if (this.state.editor.category === +e.target.value) {
      return
    }

    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        category: +e.target.value
      }
    })
  }

  onPriorityChange (e) {
    if (this.state.editor.priority === +e.target.value) {
      return
    }

    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        priority: +e.target.value
      }
    })
  }

  onCommunityChange (e) {
    if (this.state.editor.comId === e.target.value) {
      return
    }

    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        comId: e.target.value
      }
    })
  }

  render () {
    const communities = this.props.Community.my.slice().reduce((arr, c) => {
      const userGroups = (this.props.Community.groups[c.id] || [])
        .slice()
        .filter(g => g.users.includes(this.props.Auth.token.userId))
      const userPerms = user.parsePermList({ groups: userGroups })
      if (access.comSupport(userPerms)) {
        return [...arr, c]
      }
    }, [])

    return [
      <Row key={0}>
        <Col>
          <CreateForm
            onSubmit={this.onFormSubmit.bind(this)}
            onChange={this.onInputChange.bind(this)}
            onCategoryChange={this.onCategoryChange.bind(this)}
            onPriorityChange={this.onPriorityChange.bind(this)}
            onCommunityChange={this.onCommunityChange.bind(this)}
            editor={this.state.editor}
            communities={communities}
          />
        </Col>
      </Row>
    ]
  }
}

export default SupportCreate



// WEBPACK FOOTER //
// ./src/components/Support/SupportCreate.js